import { useMemo, useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error not typed
import { toFormattedString } from 'UIComponents/core/SimpleDate';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { useUserInfo } from 'marketing-platform-lib/providers/UserInfoProvider';
import FormatField from 'ExportDialog/modal/formFields/FormatField';
import createFormField from 'ExportDialog/modal/formFields/FormField';
import { DefaultFieldKeys } from 'ExportDialog/Constants';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import { URL_DATE_FORMAT } from 'asset-actions-lib-forms/constants/dateFormats';
import ExportDialog from 'asset-actions-lib-forms/exportSubmissions/AsyncExportDialog';
import ExportClientV3 from 'asset-actions-lib-forms/exportSubmissions/ExportClientV3';
import PropertiesIncludedInExport from 'asset-actions-lib-forms/exportSubmissions/PropertiesIncludedInExport';
import ExportDateRange from 'asset-actions-lib-forms/exportSubmissions/ExportDateRange';
import SendToField from 'asset-actions-lib-forms/exportSubmissions/SendToField';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SubmissionExportDialog({
  onClose,
  onConfirm
}) {
  const {
    crmObject,
    onActionError,
    nonCrmObject
  } = useAssetActions();
  const {
    userInfo
  } = useUserInfo();
  const [isNameInvalid, setIsNameInvalid] = useState(false);
  const {
    user: {
      user_id: userId,
      email: userEmail
    }
  } = userInfo;
  const {
    dateRange,
    selectedColumns = []
  } = nonCrmObject;
  const [editableDateRange, setEditableDateRange] = useState(dateRange);
  const formGuid = useMemo(() => getPropertyValue(crmObject, 'hs_form_id'), [crmObject]);
  const formName = useMemo(() => getPropertyValue(crmObject, 'hs_name'), [crmObject]);
  const handleSuccess = useCallback(() => {
    onConfirm(FORM_ACTION_IDS.EXPORT_SUBMISSIONS);
  }, [onConfirm]);
  const handleFailure = useCallback(reason => {
    onClose();
    if (onActionError) {
      onActionError({
        actionId: FORM_ACTION_IDS.EXPORT_SUBMISSIONS,
        data: reason
      });
    }
  }, [onActionError, onClose]);
  const Client = ExportClientV3({
    formGuid,
    type: 'form-submissions',
    userId,
    startDate: toFormattedString(editableDateRange.startDate, URL_DATE_FORMAT),
    endDate: toFormattedString(editableDateRange.endDate, URL_DATE_FORMAT),
    exportName: formName
  });
  const handleChange = onChange => ({
    target: {
      value: newName
    }
  }) => {
    setIsNameInvalid(!newName || newName.length === 0);
    onChange(newName);
  };
  return /*#__PURE__*/_jsx(ExportDialog, {
    client: Client,
    formFields: [...[createFormField(props => /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.exportSubmissions.name"
      }),
      required: true,
      error: isNameInvalid,
      validationMessage: isNameInvalid ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.exportSubmissions.nameError"
      }) : null,
      children: /*#__PURE__*/_jsx(TextInput, {
        required: true,
        autoFocus: true,
        value: props.value,
        defaultValue: formName,
        error: isNameInvalid,
        onChange: handleChange(props.onChange)
      }, formName)
    }, `${formName}-name-input`), 'exportName')], createFormField(FormatField, 'format'), createFormField(props => /*#__PURE__*/_jsx(SendToField, Object.assign({
      userEmail: userEmail
    }, props)), DefaultFieldKeys.EMAIL), ...[createFormField(props => /*#__PURE__*/_jsx(PropertiesIncludedInExport, Object.assign({
      selectedColumns: selectedColumns
    }, props)), 'selectedColumns'), createFormField(() => /*#__PURE__*/_jsx(ExportDateRange, {
      dateRange: editableDateRange,
      onChange: setEditableDateRange
    }), 'dateRange')]],
    topBodyContents: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.exportSubmissions.topBodyText"
    }),
    headerContents: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.exportSubmissions.heading"
    }),
    onClose: onClose,
    onFailure: handleFailure,
    onSuccess: handleSuccess,
    userEmail: userEmail,
    disableExportButton: isNameInvalid
  });
}